<!-- lead-view.component.html -->
<!-- <div class="container-fluid py-3">
    <div class="d-flex justify-content-center">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link optionone" 
             [ngClass]="{'active': activeTab === 'details'}" 
             (click)="setActiveTab('details')" 
             href="javascript:void(0)">
            View Details
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link optiontwo" 
             [ngClass]="{'active': activeTab === 'timeline'}" 
             (click)="setActiveTab('timeline')" 
             href="javascript:void(0)">
            Timeline Notes
          </a>
        </li>
      </ul>
    </div> -->
    
     <!-- lead-view.component.html -->
<div class="row">
  <div class="col-12">
    <div class="tab-content">
      <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'details'}">
        <div *ngIf="activeTab === 'details'">
          <div class="container-fluid mb-4">
            <div class="row mb-3">
              <div class="col">
                <h5 class="lead-title">Download Details - {{ lead?.name }}</h5>
              </div>
            </div>

            <form [formGroup]="leadForm">
              <div class="row">
                <!-- Left Column -->
                <div class="col-md-6">
                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" 
                             type="checkbox" 
                             id="nameCheck"
                             [checked]="fieldSelections.name"
                             (change)="onFieldSelectionChange('name', $event)">
                      <label class="form-check-label fw-bold" for="nameCheck">
                        Name <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div *ngIf="!editMode" class="form-control-static">{{ lead?.name }}</div>
                    <input *ngIf="editMode" type="text" class="form-control" formControlName="name">
                    <div *ngIf="editMode && leadForm.get('name')?.invalid && leadForm.get('name')?.touched" class="text-danger small">
                      Name is required
                    </div>
                  </div>

                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" 
                             type="checkbox" 
                             id="emailCheck"
                             [checked]="fieldSelections.email"
                             (change)="onFieldSelectionChange('email', $event)">
                      <label class="form-check-label fw-bold" for="emailCheck">
                        Email <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div *ngIf="!editMode" class="form-control-static">{{ lead?.email }}</div>
                    <input *ngIf="editMode" type="email" class="form-control" formControlName="email">
                    <div *ngIf="editMode && leadForm.get('email')?.invalid && leadForm.get('email')?.touched" class="text-danger small">
                      Valid email is required
                    </div>
                  </div>

                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" 
                             type="checkbox" 
                             id="departmentCheck"
                             [checked]="fieldSelections.department"
                             (change)="onFieldSelectionChange('department', $event)">
                      <label class="form-check-label fw-bold" for="departmentCheck">
                        Departments
                      </label>
                    </div>
                    <div *ngIf="!editMode" class="form-control-static">{{ lead?.department }}</div>
                    <input *ngIf="editMode" type="text" class="form-control" formControlName="department">
                  </div>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" 
                             type="checkbox" 
                             id="phoneCheck"
                             [checked]="fieldSelections.phone"
                             (change)="onFieldSelectionChange('phone', $event)">
                      <label class="form-check-label fw-bold" for="phoneCheck">
                        Phone
                      </label>
                    </div>
                    <div *ngIf="!editMode" class="form-control-static">{{ lead?.phone }}</div>
                    <input *ngIf="editMode" type="text" class="form-control" formControlName="phone">
                  </div>

                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" 
                             type="checkbox" 
                             id="createdCheck"
                             [checked]="fieldSelections.created"
                             (change)="onFieldSelectionChange('created', $event)">
                      <label class="form-check-label fw-bold" for="createdCheck">
                        Created On
                      </label>
                    </div>
                    <div *ngIf="!editMode" class="form-control-static">{{ lead?.created }}</div>
                    <input *ngIf="editMode" type="text" class="form-control" formControlName="created">
                  </div>

                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" 
                             type="checkbox" 
                             id="issueCheck"
                             [checked]="fieldSelections.issue"
                             (change)="onFieldSelectionChange('issue', $event)">
                      <label class="form-check-label fw-bold" for="issueCheck">
                        Issue
                      </label>
                    </div>
                    <div *ngIf="!editMode" class="form-control-static">{{ lead?.issue }}</div>
                    <input *ngIf="editMode" type="text" class="form-control" formControlName="issue">
                  </div>

                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" 
                             type="checkbox" 
                             id="statusCheck"
                             [checked]="fieldSelections.status"
                             (change)="onFieldSelectionChange('status', $event)">
                      <label class="form-check-label fw-bold" for="statusCheck">
                        Status
                      </label>
                    </div>
                    <div *ngIf="!editMode" class="form-control-static">{{ lead?.status }}</div>
                    <select *ngIf="editMode" class="form-select" formControlName="status">
                      <option selected value="active">Active</option>
                      <option value="contacted">Contacted</option>
                      <option value="qualified">Qualified</option>
                      <option value="converted">Converted</option>
                      <option value="lost">Lost</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>

            <!-- CTA Buttons -->
            <div class="cta-buttons text-center mt-4">
              <button type="button" 
                      class="btn btn-secondary me-3" 
                      (click)="onCancel()">
                Cancel
              </button>
              <button type="button" 
                      class="btn btn-primary" 
                      (click)="onReviewDetails()">
                Review Details
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>